export default __webpack_public_path__ + "./images/gp.93d35743.svg";